import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading } from '@/util/hook/custom';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import View from './View';
import { APP } from '../../config/app';
export default function Controller() {
    const { setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    useTrackBrowserHistory();
    useGetCareClientVisitorProfile({ setApiProcessingPool, setApiDonePool });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: APP.ROUTES.MARKETING_CHANNEL });
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    return <View />;
}
